const CHARGES_ENUM = {
  TPV: 'tpv',
  SALES: 'sales',
  TICKET: 'ticket'
}

const GROUP_TYPE = {
  DATE: 'date',
  TIME: 'time',
  DATETIME: 'datetime'
}

const CURRENCY_SYMBOL = {
  R$: 'R$'
}

const STEPS = {
  DECIMAL: 'decimal',
  ROUND: 'round'
}

export { CHARGES_ENUM, GROUP_TYPE, CURRENCY_SYMBOL, STEPS }

export default CHARGES_ENUM
